import { jsx as _jsx } from "react/jsx-runtime";
import { Home, KeyRound, Calendar, List, Settings, LogOut, RefreshCw, Plus, Trash2, Check, X, TriangleAlert, Clock, User, Info, LayoutDashboard, BookOpen, ClipboardList, FileText, Shield, Menu, ChevronLeft, ChevronRight, Zap, GitMerge, MapPin, Users, Pencil, Pause, Play, } from "lucide-react";
// ---------------------------------------------------------------------------
// Icon name → Lucide component mapping
// ---------------------------------------------------------------------------
const ICON_MAP = {
    home: Home,
    key: KeyRound,
    calendar: Calendar,
    list: List,
    settings: Settings,
    "log-out": LogOut,
    refresh: RefreshCw,
    plus: Plus,
    trash: Trash2,
    check: Check,
    x: X,
    "alert-triangle": TriangleAlert,
    clock: Clock,
    user: User,
    info: Info,
    // Shell nav icons
    "layout-dashboard": LayoutDashboard,
    "book-open": BookOpen,
    "clipboard-list": ClipboardList,
    "file-text": FileText,
    shield: Shield,
    menu: Menu,
    "chevron-left": ChevronLeft,
    "chevron-right": ChevronRight,
    zap: Zap,
    "git-merge": GitMerge,
    "map-pin": MapPin,
    users: Users,
    pencil: Pencil,
    pause: Pause,
    play: Play,
};
/** Backward-compatible name set for consumers that check icon existence. */
export const ICON_PATHS = Object.fromEntries(Object.keys(ICON_MAP).map((k) => [k, k]));
// ---------------------------------------------------------------------------
// Generic Icon component — delegates to Lucide
// ---------------------------------------------------------------------------
export function Icon({ name, size = 14, color = "currentColor", strokeWidth = 2, style, }) {
    const LucideComponent = ICON_MAP[name];
    if (!LucideComponent) {
        return null;
    }
    return _jsx(LucideComponent, { size: size, color: color, strokeWidth: strokeWidth, style: style });
}
